/** Mały deterministyczny generator (mulberry32) — ta sama lekcja daje tę samą kolejność. */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function shuffle<T>(items: readonly T[], seed: number): T[] {
  const rnd = mulberry32(seed);
  const a = items.slice();
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(rnd() * (i + 1));
    const tmp = a[i] as T;
    a[i] = a[j] as T;
    a[j] = tmp;
  }
  return a;
}

/** Jak shuffle, ale gwarantuje inną kolejność niż wejściowa (o ile elementy nie są identyczne). */
export function shuffleDifferent<T>(items: readonly T[], seed: number): T[] {
  if (items.length < 2 || new Set(items).size < 2) return items.slice();
  for (let k = 0; k < 20; k++) {
    const s = shuffle(items, seed + k * 101);
    if (s.some((x, i) => x !== items[i])) return s;
  }
  return items.slice().reverse();
}
